import Edit from './edit';
import PassboardBanner from '../common/banner';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const PassboardNew = () => {
  return (
    <div className={cx('wrapper')}>
      <PassboardBanner />

      <div className={cx('edit')}>
        <Edit />
      </div>
    </div>
  );
};

export default PassboardNew;
